























































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import CategorySideMenuComponent, {
  CategorySideMenuSensor,
  GetStoreSensorsResponseSensor,
  CategorySideMenuIcon
} from "@/components/layout/CategorySideMenuComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import WarningHistoriesMainComponent from "@/components/pages/warning_histories/WarningHistoriesMainComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { storeMenus } from "@/config/store_menus";
import { WarningHistory } from "@/typescript/pages/warning_histories/types";
import { getStoreSensorsApi } from "../typescript/api_client/emesh_api/stores/store_sensors_api";
import { getAlertHistoryApi } from "../typescript/api_client/emesh_api/alert_histories/alert_history_api";
import { Moment } from "../typescript/lib/common/moment";
import { getEquipmentsApi } from "../typescript/api_client/emesh_api/equipments/equipments_api";
import { getAlertHistoryCsvApi } from "@/typescript/api_client/emesh_api/alert_histories/alert_history_csv_api";
import { getAlertHistoryAlertStatusApi } from "@/typescript/api_client/emesh_api/alert_histories/alert_history_alert_status_api";
import { convertNullObject } from "@/typescript/lib/common/convert_null_object";
import { GetStoreSensorsResponse } from "./temp_managements/TempManagementsListPage.vue";
import { fillZero } from "@/typescript/lib/common/fill_zero";
import {
  GetAlertHistoryParams,
  GetAlertHistoryCsvParams
} from "../typescript/api_client/emesh_api/alert_histories/types";
import { postAlertHistoryApi } from "@/typescript/api_client/emesh_api/alert_histories/alert_history_api";
export {
  WarningHistory,
  GetStoreSensorsResponse,
  GetAlertHistoryParams,
  GetAlertHistoryCsvParams,
  CategorySideMenuSensor,
  GetStoreSensorsResponseSensor,
  CategorySideMenuIcon
};

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    CategorySideMenuComponent,
    WarningHistoriesMainComponent,
    ConfirmDialogComponent,
    ButtonComponent,
    FooterComponent
  }
})
export default class WarningHistoriesPage extends Vue {
  warningHistory: WarningHistory | {} = {};
  storeName = "";
  currentPageNo: number = 1;
  alertHistoryApiParams = {};
  storeSensors: GetStoreSensorsResponseSensor[] = [];
  categorySideMenuSensors: CategorySideMenuSensor[] = [];
  sensorIcons: CategorySideMenuIcon[] = [];
  isStopAlertDialog: boolean = false;
  equipmentId: string = "";
  alertId: string = "";

  get hasData() {
    // 2021.08.24 センサ一覧が常に表示されるよう修正
    return false;
    //if (Object.keys(this.warningHistory).length === 0) return false;
    //const warningHistories = this.warningHistory as WarningHistory;
    //return warningHistories.allCount === 0;
  }

  created() {
    this.$store.commit("setActiveId", {
      activeId: storeMenus().find(m => m.pageName === "WarningHistoriesPage")
        ?.id
    });
    this.setApiData();
  }

  async setApiData() {
    const storeSensors = await getStoreSensorsApi(this.$route.params.store_id);
    this.storeName = storeSensors.store_name;
    this.storeSensors = storeSensors.sensors;
    this.categorySideMenuSensors = this.storeSensors
      .map(ss => {
        return {
          equipmentId: ss.equipment_id,
          equipmentName: ss.equipment_name,
          iconKind: ss.icon_kind,
          isChecked: true,
          locationNo:
            ss.location_no === null ? "00" : fillZero(ss.location_no, 2),
          lowerLimit: ss.lower_limit === null ? "--" : ss.lower_limit
        };
      })
      // 2021.08.24 センサが下限閾値順になるよう修正
      //.sort((a, b) => Number(a.locationNo) - Number(b.locationNo));
      .sort((a, b) => Number(a.lowerLimit) - Number(b.lowerLimit));
    const iconKinds = this.storeSensors
      .map(ss => {
        return {
          iconKind: ss.icon_kind,
          status: "on"
        };
      })
      .filter((icon, index, self) => {
        return (
          self.findIndex(icon2 => {
            return icon.iconKind === icon2.iconKind;
          }) === index
        );
      }) as CategorySideMenuIcon[];

    this.sensorIcons = iconKinds.map(i => {
      const sensors = this.storeSensors.filter(
        (e: any) => e.icon_kind === i.iconKind
      );
      return {
        ...i,
        sensors: sensors
      };
    }) as CategorySideMenuIcon[];

    this.setWarningHistories(1);
  }

  async makeWarningHistories(
    sensors: CategorySideMenuSensor[],
    now: string,
    beforeCurrentAMonth: string,
    pageNo: number
  ) {
    const equipmentIds: string = sensors.map(s => s.equipmentId).join(",");

    if (!equipmentIds) return { allCount: 0, data: [] };

    const alertStatus = await getAlertHistoryAlertStatusApi({
      equipment_id: equipmentIds
    });

    this.alertHistoryApiParams = {
      equipment_id: equipmentIds,
      start_date: beforeCurrentAMonth,
      end_date: now
    };

    const alertHistory = await getAlertHistoryApi({
      ...this.alertHistoryApiParams,
      page_count: 10,
      page_no: pageNo
    } as GetAlertHistoryParams);
    return {
      allCount: alertHistory.all_count,
      data: await Promise.all(
        alertHistory.alerts.map(async a => {
          const status = alertStatus.status.find(
            d => d.equipment_id === a.equipment_id && d.alert_id === a.alert_id
          );
          const equipment = await getEquipmentsApi(a.equipment_id);
          const res = {
            alertData1: a.alert_data1,
            alertId: a.alert_id,
            equipmentId: equipment.equipment_id,
            equipmentName: equipment.equipment_name,
            iconKind: equipment.icon_kind,
            lowerLimit: a.lower_limit,
            startDate: a.start_date,
            upperLimit: a.upper_limit,
            isAlertStatus: status ? true : false
          };
          return convertNullObject(res, "--", [
            "equipmentName",
            "lowerLimit",
            "upperLimit"
          ]);
        })
      )
    };
  }

  async setWarningHistories(pageNo: number) {
    const apiDateFormat = "YYYYMMDD";
    const now = new Moment(apiDateFormat).getFormatDate();
    const beforeCurrentAMonth = new Moment(
      apiDateFormat,
      now,
      apiDateFormat
    ).addDate(-1, "month");
    const checkedStoreSensors = this.categorySideMenuSensors.filter(csms => {
      return csms.isChecked;
    });

    const warningHistory: WarningHistory = await this.makeWarningHistories(
      checkedStoreSensors,
      now,
      beforeCurrentAMonth,
      pageNo
    );
    this.warningHistory = warningHistory;
  }

  changePage(num: number) {
    this.currentPageNo = num;
    this.setWarningHistories(this.currentPageNo);
  }

  moveNextPage(isMove: boolean) {
    if (!isMove) return;
    this.currentPageNo += 1;
    this.setWarningHistories(this.currentPageNo);
  }

  movePrevPage(isMove: boolean) {
    if (!isMove) return;
    this.currentPageNo -= 1;
    this.setWarningHistories(this.currentPageNo);
  }

  downloadCsv() {
    getAlertHistoryCsvApi(
      this.alertHistoryApiParams as GetAlertHistoryCsvParams
    ).catch(() => {
      alert(
        "警報履歴一覧CSVをダウンロードできませんでした。再度お試しください。"
      );
    });
  }

  onCheck(sensor: CategorySideMenuSensor) {
    this.checkCategorySensor(sensor);
    this.setWarningHistories(1);
  }

  checkCategorySensor(sensor: CategorySideMenuSensor) {
    this.categorySideMenuSensors[
      this.categorySideMenuSensors.findIndex(
        csms => csms.equipmentId === sensor.equipmentId
      )
    ].isChecked = sensor.isChecked;
  }

  onClickIcon(icon: CategorySideMenuIcon) {
    icon.sensors?.forEach(s => {
      const ele = document.getElementById(
        `category_side_menu_component_${s.equipment_id}`
      ) as HTMLInputElement;
      ele.checked = icon.status === "off";
      this.checkCategorySensor({
        equipmentId: s.equipment_id,
        equipmentName: s.equipment_name,
        locationNo: s.location_no === null ? "00" : fillZero(s.location_no, 2),
        iconKind: s.icon_kind,
        isChecked: icon.status === "off"
      });
    });
    this.sensorIcons[
      this.sensorIcons.findIndex(e => e.iconKind === icon.iconKind)
    ].status = icon.status === "off" ? "on" : "off";
    this.setWarningHistories(1);
  }

  stopAlertDialog(stopAlert: any) {
    this.equipmentId = stopAlert.equipmentId;
    this.alertId = stopAlert.alertId;
    this.isStopAlertDialog = true;
  }

  stopAlert() {
    const postData = {
      equipment_id: this.equipmentId,
      alert_id: this.alertId
    };
    postAlertHistoryApi(postData)
      .then(() => {
        this.setWarningHistories(this.currentPageNo);
      })
      .catch(() => {
        alert("警報停止に失敗しました。");
      })
      .finally(() => {
        this.closeStopAlertDialog();
      });
  }

  closeStopAlertDialog() {
    this.isStopAlertDialog = false;
  }
}
